import React from 'react'
import {Toaster} from 'react-hot-toast'
import TripForm from './TripForm'
import {useNavigate} from 'react-router-dom'

const TripUpload: React.FC = () => {
  const navigate = useNavigate()
  return (
    <div>
      <div className="fv-row card">
        <TripForm onAfterSubmit={() => navigate('/users/student')} />
      </div>
      <Toaster />
    </div>
  )
}

export default TripUpload
